
const morph = document.getElementById('morph');
const blur = document.getElementById('blur');
const menuButton = document.querySelector('.menu-button');




export function show_logo(){
    
    const startValue = parseInt(morph.getAttribute('radius'));
    const endValue = 0;
    const duration = 600;

    if(window.browser === 'macOS Safari'){
      morph.setAttribute('radius', endValue);
      menuButton.style.opacity = 1;

    }else{
      animateEaseOut(startValue, endValue, duration, (value) => {
          morph.setAttribute('radius', value.toFixed(1));
          // blur.setAttribute('stdDeviation', value/10);
        // console.log(value);
      }, () => {
        menuButton.style.opacity = 1;
      });
    }

};


export function hide_logo(){
    
    const startValue = parseInt(morph.getAttribute('radius'));
    const endValue = 60;
    const duration = 1000;

    if(window.browser === 'macOS Safari'){
     
      morph.setAttribute('radius', endValue);
      menuButton.style.opacity = 1;

    }else{
    animateEaseOut(startValue, endValue, duration, (value) => {
        morph.setAttribute('radius', value.toFixed(1));
    }, () => {
      // console.log("Animation complete!");
    });
  }
};





function animate(from, to, duration, onUpdate, onComplete) {
    const startTime = performance.now();
  
    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1); 
      const value = from + (to - from) * progress;
  
      onUpdate(value); // Call the update function with the new value
  
      if (progress < 1) {
        window.requestAnimationFrame(update); // Continue the animation
      } else if (onComplete) {
        onComplete(); // Call the complete function if provided
      }
    }
  
    window.requestAnimationFrame(update); // Start the animation
  }

  
  function animateEaseOut(from, to, duration, onUpdate, onComplete) {


    const startTime = performance.now();
  
    function easeOut(t) {
        return 1 - Math.pow(1 - t, 5); // More extreme ease-out effect with higher power

    }
  
    function update(currentTime) {

      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1); 
      const easedProgress = easeOut(progress); // Apply the ease-out function
      const value = from + (to - from) * easedProgress; // Interpolate with eased progress
  
      onUpdate(value); 
  
      if (progress < 1) {
        window.requestAnimationFrame(update); // Continue the animation
      } else if (onComplete) {
        onComplete(); // Call the complete function if provided
      }
    }
  
    window.requestAnimationFrame(update); // Start the animation

  }




  function IsSafari() {

    var is_safari = navigator.userAgent.toLowerCase().indexOf('safari/') > -1;
    return is_safari;
  
  }